import module from 'cliente/module.js'
import template from './template.html'
import { orderBy } from 'lodash'

export class ClienteInformacionAccionistasAgregarComponent {
  idCliente
  onClose
  error = null
  catalogos = {}
  procesando = false
  data = {
    nombre: '',
    rfc: '',
    curp: '',
    porcentaje_participacion: null,
    id_pais: undefined,
    id_nacionalidad: undefined,
  }

  constructor ($state, CatalogoNacionalidad, ClienteInformacionAccionistas) {
    this.$state = $state
    this.CatalogoNacionalidad = CatalogoNacionalidad
    this.ClienteInformacionAccionistas = ClienteInformacionAccionistas
  }

  $onInit () {
    this.promise = this.CatalogoNacionalidad.get()
      .then(({data}) => {
        this.catalogos.paises = orderBy(data, ['descripcion'])
        this.catalogos.nacionalidades = orderBy(data, ['descripcion'])
      })
  }

  agregar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.ClienteInformacionAccionistas.post(this.idCliente, this.data)
      .then(() => (this.cerrar()))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.$state.go('cliente.informacion.accionistas')
  }
}

module.component('clienteInformacionAccionistasAgregar', {
  controller: ClienteInformacionAccionistasAgregarComponent,
  template,
  bindings: {
    idCliente: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/accionistas/agregar/component.js